/**
 * Represents the type of an [[Order]].
 */
export var OrderType;
(function (OrderType) {
    /**
     * An order where [[TicketType]] and/or [[Item]] entities are purchased from a [[Site]].
     */
    OrderType["Standard"] = "Standard";
    /**
     * An order where [[Item]] entities are purchased from the Gift Shop.
     */
    OrderType["GiftShop"] = "GiftShop";
    /**
     * An order where a [[SubscriptionBillingOption]] is purchased.
     */
    OrderType["Subscription"] = "Subscription";
})(OrderType || (OrderType = {}));
//# sourceMappingURL=order-type.js.map